<script>
    import { redirect } from '@sveltech/routify'
    import { authStore, Authenticator } from 'totalinvoice-frontend-core'
    import { config } from '../../common/Config'
    import E503 from '../_503.svelte'

    if ($authStore.authenticated) {
        // user is logged in -> logout using keycloak
        Authenticator.logout()

        config.storage.clear()
    }

    // redirect to front page
    $redirect("/")
</script>

{#if $authStore.initialized}
    <slot />
{:else}
    <E503 />
{/if}
